module.exports = __webpack_public_path__ + "img/OperaBrowser.a069885f.svg";